const TIKTOK_LINK = 'https://www.tiktok.com/@letscelebrate.vn';
const INSTAGRAM_LINK = 'https://www.instagram.com/lets.celebrate.vn/';
const FACEBOOK_LINK = 'https://www.facebook.com/letscelebratevn?locale=vi_VN';
const MESSENGER_LINK = 'http://m.me/letscelebratevn';
const DEFAULT_LANG = 'vi';

module.exports = {
	TIKTOK_LINK, FACEBOOK_LINK, INSTAGRAM_LINK, MESSENGER_LINK, DEFAULT_LANG
}